import {
  Box,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  useSteps,
} from '@chakra-ui/react';

const RStepper = ({
  steps,
  isError,
  isSuccess,
}: {
  steps: { title: string; description: string; reason?: string }[];
  isError?: boolean;
  isSuccess?: boolean;
}) => {
  const { activeStep } = useSteps({
    index: steps.length,
    count: steps.length,
  });

  return (
    <Stepper
      index={activeStep}
      size='xs'
      colorScheme={isError ? 'red' : isSuccess ? 'green' : 'blue'}
      flexGrow={1}
    >
      {steps.map((step, index) => (
        <Step key={index}>
          <StepIndicator>
            <StepStatus
              complete={<StepIcon />}
              incomplete={<StepNumber />}
              active={<StepNumber />}
            />
          </StepIndicator>

          <Box flexShrink='0'>
            <StepTitle>{step.title}</StepTitle>
            <StepDescription>{step.description}</StepDescription>
            {step.reason && <StepTitle>Motif: {step.reason}</StepTitle>}
          </Box>

          <StepSeparator />
        </Step>
      ))}
    </Stepper>
  );
};

export default RStepper;
